import React, { Component } from 'react';
import { PaymentService } from '../services/PaymentService'
import { Translate } from '../contexts/LanguageContext';

export class ExchangeConverter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            amount: 0,
            price: 0,
            currency: ""
        }
        this.price = 0;
        this.currency = "";
    }
    shouldComponentUpdate(nextProps, nextState) {

        this.currency = nextProps.Currency;

        if ((this.price <= 0 && this.currency !== "") || (this.state.currency !== "" && this.state.currency !== this.currency)) {
            PaymentService.Price({ 'Symbol': this.currency }).then(response => {
                this.price = response;
                this.setState({
                    price: response.toFixed(4),
                    currency: this.currency,
                    amount: nextProps.Amount
                })
            });
        }

        return true;
    }

    calculateUSDAmount(amount) {
        return (amount * this.state.price).format('c')
    }


    render() {
        return (
            <div className={this.props.className}>
                <label htmlFor="calculatedAmount" className="col-sm-2 col-form-label">{Translate("USD Amount")} <small>(1 {this.state.currency}={this.state.price} USD)</small></label>
                <div className="col-sm-5">
                    <label className="form-control">
                        {this.calculateUSDAmount(this.props.Amount)}
                    </label>
                </div>
            </div>
        )
    }

}